module.exports = __webpack_public_path__ + "static/media/close.420b30c4.svg";